<script>
    import Main from './layout/Main.svelte';
    import Chat from '../com/Chat/Chat.svelte'
    import { t } from "../i18n";

    let chat;

</script>


<Main title={$t('page.chat')}>
    <div class="app-content content">
        <div class="content-overlay"></div>
        <div class="content-wrapper">

            <div class="container-fluid">
                <div class="row">
                    <div class="col">
                        <Chat bind:this={chat} path="/"></Chat>
                    </div>
                </div>
            </div>
        </div>
    </div>
</Main>
